import React from 'react';

const ButtonsContainer = (props) => {
  const children = React.Children.toArray(props.children);
  if (children.length === 1) {
    return (
      <div className="buttonsContainer">
        {
          React.cloneElement(
            children[0],
            { ...children[0].props, style: { alignSelf: 'flex-start' } },
          )
        }
      </div>
    );
  }
  return (
    <div className="buttonsContainer">
      {
        React.cloneElement(
          children[0],
          { ...children[0].props, style: { alignSelf: 'flex-start' } },
        )
      }
      {
        React.cloneElement(
          children[1],
          { ...children[1].props, style: { alignSelf: 'flex-end' } },
        )
      }
    </div>
  );
};

export default ButtonsContainer;



// WEBPACK FOOTER //
// ./src/components/buttonsContainer.js